import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GlobalRegistryService } from '../../../core/global-registry/global-registry.service';
import { Subscription } from 'rxjs';
import { NavService } from '../../../shared/services/nav.service';
import { ActivityModel } from '../../../core/models/activity/activity.model';
import { ToastrService } from 'ngx-toastr';
import { ResponseModel } from '../../../core/models/response.model';
import { ActivityService } from '../../../core/services/api/activity/activity.service';
import { CacheResolverService } from '../../../core/services/api/cache/cache-resolver.service';
import { ActivityTypeModel } from '../../../core/models/activity/activity-type.model';
import { PlanTypeModel } from '../../../core/models/company/plan.type.model';
import { MapService } from '../../../shared/layout/fap_main-map/service/map-service';
import { WidgetsService } from '../../../core/services/api/widgets/widgets.service';
import { PlanModel } from '../../../core/models/company/plan.model';
import { TypesService } from '../../../core/services/api/types/types.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FapModalComponent } from '../../../shared/partials';
import { MatSelect } from '@angular/material/select';
import { EquipmentModel } from '../../../core/models/equipment/equipment.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'fap-planning',
  templateUrl: './planning.component.html',
  styleUrls: ['./planning.component.scss']
})
export class PlanningComponent implements OnInit, OnDestroy, AfterViewInit {

  public langString;
  public subscriptions: Array<Subscription> = [];
  public activities: any = [];
  public searchString: string ='';
  public count: number = 0;
  public pageNumber: number = 1;
  public isLoading: boolean = false;
  public activityTypes: Array<ActivityTypeModel>;
  public planTypes: Array<PlanTypeModel>;
  public plans: Array<PlanModel>;
  public nextToken: { offset: number; limit: number } = null;
  public limit = 20;
  public offset = 0;
  public getMore = true;
  public dateColumns: Date[];
  public columnWidth = 60;
  public activityRows = [];
  public planData;
  public plan;
  public planType;
  public planId: number = null;
  public isActive = false;
  public selectedPlans: any[] = [];
  public defaultCurrency: number;
  public activity = null;
  public equipments: Array<EquipmentModel> = [];
  public baselineActivityId = null;
  public baselineActivity: ActivityModel;
  public formTypes = [];
  public resetActivityForm: boolean = false;

  @ViewChild('addEditBaselineActivityModal')
  public addEditBaselineActivityModal: FapModalComponent;
  @ViewChild('addEditActivityModal')
  public addEditActivityModal: FapModalComponent;

  @ViewChild('datesContainer') datesContainer: ElementRef;
  @ViewChild('addEditPlanModal') public addEditPlanModal: FapModalComponent;
  @ViewChild('mys') mys: MatSelect;

  constructor(public globalRegistry: GlobalRegistryService, public navService: NavService, private toastr: ToastrService, private activityService: ActivityService, private cacheService: CacheResolverService, private mapService: MapService, private widgetService: WidgetsService, private typeService: TypesService, private router: Router, public route: ActivatedRoute, private translate: TranslateService) {}

  ngOnInit(): void {
    this.langString = localStorage.getItem('language');
        this.subscriptions.push(this.navService.getCurrentLanguage.subscribe(lang => {
            if(lang) {
                this.langString = lang;
            }
    }));
    this.plans = this.globalRegistry.systemData.plans;
    this.defaultCurrency = this.globalRegistry.systemData.company.currency;
    // this.getActivities();
    this.getFormTypes();
    this.getActivityPlans();
    this.getActivityTypes();
    this.getPlanTypes();
    this.widgetService.setMapResize(false);
    this.widgetService.setSize(12);
    this.mapService.hideMap();
    console.log(this.globalRegistry.systemData.plans)
  }

  ngAfterViewInit() {
    this.enableDragScroll();
  }

  enableDragScroll() {
    const datesContainer = this.datesContainer.nativeElement;
    let isDown = false;
    let startX: number;
    let scrollLeft: number;
  
    datesContainer.addEventListener('mousedown', (e) => {
      isDown = true;
      datesContainer.classList.add('active');
      startX = e.pageX - datesContainer.offsetLeft;
      scrollLeft = datesContainer.scrollLeft;
    });
  
    datesContainer.addEventListener('mouseleave', () => {
      if (isDown) {
        isDown = false;
        datesContainer.classList.remove('active');
      }
    });
  
    datesContainer.addEventListener('mouseup', () => {
      if (isDown) {
        isDown = false;
        datesContainer.classList.remove('active');
      }
    });
  
    datesContainer.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - datesContainer.offsetLeft;
      const walk = (x - startX) * 2; // The multiplier can be adjusted for faster/slower scrolling
      datesContainer.scrollLeft = scrollLeft - walk;
    });
  }  

  getActivityPlans() {
    let url = this.activityService.getUrl('plan/deep=1');
    this.activityService.getActivityPlans({deep: 1}).subscribe(data => {
      this.cacheService.delete(url);
      console.log(data);
      this.planData = data.body;
      this.activities = this.planData.rows;
      if(this.planData.period.start) {
        this.generateDateColumns(this.planData.period.start, this.planData.period.end);
      }
    })
  }

  private getActivityTypes(): void {
    this.typeService
      .getActivityTypes()
      .subscribe((response: ResponseModel<ActivityTypeModel[]>) => {
        this.activityTypes = response.model;
      });
  }

  public getPlanTypes() {
    let url = this.typeService.getUrl('plan/');
    this.cacheService.delete(url);
    this.typeService.getPlanTypes().subscribe((types:ResponseModel<PlanTypeModel[]>) => {
      this.planTypes = types.model;
    })
  }

  filterActivitiesByPlan(event) {
    this.mys.close();
    if(event.value.length === 0) {
      this.getActivityPlans();
      this.plan = null;
      this.planType = null;
    } else {
      if (event.value.length === 1) {
        this.plan = this.plans.find(plan => plan.id === event.value[0]) || null;
        this.planType = this.planTypes.find(planType => planType.id === this.plan?.type) || null;
      } else {
        this.plan = null;
      }
      console.log(this.plan);
      console.log(this.planType);
      let url = this.activityService.getUrl('plan/');
      let params = {list: event.value.toString(), deep: 1}
      this.activityService.getActivityPlans(params).subscribe(data => {
        this.cacheService.delete(url+'list='+event.value.toString()+'&deep=1');
        console.log(data);
        this.planData = data.body;
        this.activities = this.planData.rows;
        if(this.planData && this.planData.period) {
          this.generateDateColumns(this.planData.period.start, this.planData.period.end);
        }
      })
    }
  }

  filterPlans(ev) {
    console.log(ev);
  }

    getTranslation(translation) {
      const t =this.globalRegistry.systemData.translations.filter(trans => {
        return trans.id === translation
      });
      if(t[0]) {
        if(t[0][this.langString] === null || t[0][this.langString] === '') {
          return translation
        } else {
          return t[0][this.langString];
        }
      } else {
          return translation
        }
    }

    public handlePagination(pageNumber: number) {
      this.pageNumber = pageNumber;
      console.log(pageNumber);
      console.log(this.limit);
      console.log(pageNumber * this.limit);
      this.offset = pageNumber * this.limit - this.limit;
    }

    generateDateColumns(startDate: string, endDate: string): void {
      this.dateColumns = [];
      const start = new Date(startDate);
      const end = new Date(endDate);
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        this.dateColumns.push(new Date(d));
      }
    }
  
    getActivityTypeColor(activityTypeId: number) {
      let color = '#BA6969';
      this.activityTypes.forEach(type => {
        if(type.id === activityTypeId) {
          color = type.color;
        }
      });
      return color;
    }

    getActivityOverlayWidth(start: number, end: number): string {
      const totalDays = end - start + 1; // Assuming start and end are indices
      return (totalDays * this.columnWidth) + 'px';
    }
    
    getActivityOverlayPosition(start: number): string {
      const leftPosition = start * this.columnWidth;
      return (leftPosition) + 'px';
    }

    toggleActivityRow() {
      this.isActive = !this.isActive;
    }

    getChildActivityPlan(activityId: number) {
      this.activityService.getActivityPlanById(activityId).subscribe(data => {
        console.log(data);
      })
    }

    openPopup() {
      // this.router.navigate([], {
      //   relativeTo: this.route,
      //   queryParams: { mode: 'edit' },
      //   queryParamsHandling: 'merge'
      // });
    }
    
    editCrop() {
      console.log(this.plan);
      this.addEditPlanModal.showModal();
    }

    public updatePlan(plan) {
      this.plan = plan;
      const indexToUpdate = this.globalRegistry.systemData.plans.findIndex(s => s.id === plan.id);
      if (indexToUpdate !== -1) {
          this.globalRegistry.systemData.plans[indexToUpdate] = plan;
          this.plans = this.globalRegistry.systemData.plans;
      } else {
          console.warn(`Plan with ID ${plan.id} not found in the global registry`);
      }
      this.addEditPlanModal.hideModal();
  }

  public getFormTypes() {
    const url = this.typeService.getUrl('form/');
    this.cacheService.delete(url);
    this.typeService.getFormTypes().subscribe((data) => {
        this.formTypes = data.body.results;
        console.log(data.body.results);
    });
  }

  public getActivity(activityId: number) {
    this.activityService.getActivity(activityId).subscribe(data => {
        this.activity = data.model;
        this.addEditActivityModal.showModal();
    }, (error) => {
        this.toastr.error(error.error.results.error);
    })
}

  createNewActivity() {
    this.activity = null;
    this.activityService.createActivity({}).subscribe(data => {
      this.activity = data.model;
      this.addEditActivityModal.showModal();
    })
  }

  public deleteActivity(id): void {
    console.log(id);
      this.activityService.deleteActivity(id).subscribe(data => {
        this.toastr.success(this.translate.instant("activity.activityDeletedSuccessfully"));
        this.activityService.setActivityList(true);
        this.addEditActivityModal.hideModal();
      }, (err) => {
        this.toastr.error(err.error.results.error)
      })
  }

  public submitActivity(activity: ActivityModel): void {
    console.log(activity);
    this.activityService.createActivity(activity).subscribe(data => {
        if(data) {
          this.getActivityPlans();
            this.toastr.success(
                this.translate.instant("activity.activityCreatedSuccessfully")
              );
              this.activityService.setActivityList(true);
              this.globalRegistry.reloadPlans();
        }
    }, (err) => {
      this.toastr.error(err.error.results.error)
    })
  }

  public updateActivity(activity: ActivityModel): void {
      this.activityService.updateActivity(activity.id, activity).subscribe(data => {
        if(data) {
          this.getActivityPlans();
            this.toastr.success(
                this.translate.instant("activity.activityUpdatedSuccessfully")
              );
              this.activityService.setActivityList(true);
              this.globalRegistry.reloadPlans();
        }
      }, (err) => {
        this.toastr.error(err.error.results.error)
      })
  }

  setBaselineTrigger(activity) {
    console.log(activity)
      this.activity = activity;
      if(activity.baseline) {
          console.log(activity.baseline)
      } else {
          this.createBaselineActivity(activity)
      }
    }

    public createBaselineActivity(activity) {
      const activityData = {};
      this.activityService.createBaselineActivity(activityData, activity.id).subscribe(data => {
          if(data) {
              console.log(data.model);
              this.baselineActivity = data.model;
              this.activity.baseline = data.model.id
          }
      })
    }

    assignBaselineActivity(activityId) {
      this.baselineActivityId = activityId;
      this.addEditBaselineActivityModal.showModal();
    }

    public deleteBaselineActivity(id): void {
      console.log(id);
        this.activityService.deleteActivity(id).subscribe(data => {
          this.toastr.success(this.translate.instant("activity.baselineActivityDeletedSuccessfully"));
          this.addEditBaselineActivityModal.hideModal();
          this.activity.baseline = null;
        }, (err) => {
          this.toastr.error(err.error.results.error)
        })
    }

    public submitBaselineActivity(activity: ActivityModel): void {
      console.log(activity);
      this.activityService.createActivity(activity).subscribe(data => {
          if(data) {
              this.toastr.success(
                  this.translate.instant("activity.baselineActivityCreatedSuccessfully")
                );
                this.activity.baseline = data.model.id;
          }
      }, (err) => {
          this.toastr.error(err.error.results.error)
        })
    }

    public updateBaselineActivity(activity: ActivityModel): void {
        this.activityService.updateActivity(activity.id, activity).subscribe(data => {
          if(data) {
              this.toastr.success(
                  this.translate.instant("activity.baselineActivityUpdatedSuccessfully")
                );
                this.activity.baseline = data.model.id;
          }
        }, (err) => {
          this.toastr.error(err.error.results.error)
        })
    }

    ngOnDestroy(): void {
      this.subscriptions.forEach(s => {
        s.unsubscribe();
      });
      this.widgetService.setMapResize(true);
    }
}
